import { Platform } from '@hotstar/platforms';
import { ConfigFilterKeyList } from '@hotstar/config';

export const PLATFORMS_WITH_CONFIG: Platform[] = [
  Platform.WEBOS,
  Platform.CHROMECAST,
  Platform.MCA,
  Platform.PLAYSTATION,
  Platform.XBOX,
  Platform.VIDAA,
  Platform.ASTRO,
  Platform.TIZENTV,
  Platform.KEPLER,
  Platform.COOLITA
];

export const configFilterList: ConfigFilterKeyList[] = [
  ConfigFilterKeyList.ALL,
  ConfigFilterKeyList.COMMON,
  ConfigFilterKeyList.PLAYBACK,
  ConfigFilterKeyList.WEB,
  ConfigFilterKeyList.WEBLR,
  ConfigFilterKeyList.WEBOS,
  ConfigFilterKeyList.MCA,
  ConfigFilterKeyList.PLAYSTATION,
  ConfigFilterKeyList.TIZENTV,
  ConfigFilterKeyList.XBOX,
  ConfigFilterKeyList.KEPLER,
  ConfigFilterKeyList.COOLITA,
  ConfigFilterKeyList.VIDAA
];
